export default (value) => (!value ? value : value.replace(/[^0-9]/gi, ''));
